import { HqApiService } from 'hq/services/hqApiService';
import { OgpApiService } from 'ogp/services/ogp-api-service';
import { CancelationReason } from 'ogp/services/shift-claim-service.types';
import { PartnerApiService } from 'partner/shared/services/partner-api-service';
import { Site } from 'shared/hooks';

export class ShiftClaimService {
  constructor(
    private readonly ogpApiService: OgpApiService,
    private readonly hqApiService: HqApiService,
    private readonly partnerApiService: PartnerApiService
  ) {}

  public async cancelShiftClaim(
    site: Site,
    shiftClaimId: string,
    cancelationReason: CancelationReason | null
  ): Promise<void> {
    const path = `shift-claims/cancel-claim/${shiftClaimId}`;

    if (site === 'hq') {
      return await this.hqApiService.update<void>({
        path,
        body: {
          cancelationReason,
        },
      });
    }

    if (site === 'ogp') {
      return await this.ogpApiService.update<void>({
        path,
        body: {
          cancelationReason,
        },
      });
    }

    if (site === 'partner') {
      return await this.partnerApiService.update<void>({
        path,
        body: {
          cancelationReason,
        },
      });
    }

    throw new Error('Not implemented');
  }
}
